class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.currentPage = Number(this.dataset.currentPage);
    this.totalPages = Number(this.dataset.totalPages);
    this.button = this.querySelector('#load-more-button');

    if (this.currentPage >= this.totalPages) {
      this.button.setAttribute('disabled', 'true');
      this.button.textContent = 'No more products';
    }

    if (this.button) {
      this.button.addEventListener('click', () => this.handleButtonClick());
    }
  }

  handleButtonClick() {
    const destination = document.getElementById('main-collection-product-grid');
    const existingItems = destination.querySelectorAll('li');
    const lastExistingItem = existingItems[existingItems.length - 1];

    // Refocus to the last existing product's anchor
    if (lastExistingItem) {
      const anchor = lastExistingItem.querySelector('a');
      if (anchor) {
        anchor.setAttribute('tabindex', '-1'); // Ensure it's focusable if not already
        anchor.focus();
      }
    }
    
    const nextPage = this.currentPage + 1;

    this.renderNextPage(nextPage);
    this.currentPage = nextPage;

    if (nextPage >= this.totalPages) {
      this.button.setAttribute('disabled', 'true');
      this.button.textContent = 'No more products';
      return;
    }
  }

  renderNextPage(page) {
    const section = document.getElementById('main-collection-product-grid').dataset.id;
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.append('page', page);

    const url = `${window.location.pathname}?section_id=${section}&${searchParams.toString()}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const destination = document.getElementById('main-collection-product-grid');
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelectorAll('#main-collection-product-grid li');

        let fragment = new DocumentFragment();
        source.forEach((item) => fragment.appendChild(item));

        destination.append(fragment);

        // fix bug in Safari where srcset doesn't render correctly for images loaded asynchronously
        this.reloadSrcsetImgs(document);
      });
  }

  reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll('img[srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
